import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import Select from 'react-select';

import { BackButton, ActionButton } from '../common';
import { getPrintedForm, stateContractReset } from '../../redux/actions/contractAction';
import { createArrayYears, dataYears } from '../../helpers/common';
import { Message } from '../utilites';

import './reportsNBRB.scss';
import {viewReports} from "../../helpers/data-constants";

const ReportsNBRB = () => {
  const { commonError, isLoading } = useSelector(({ contract }) => contract);
  const [ reportTitle, setReportTitle] = useState('')
  const [state, setState] = useState(null);

  const dispatch = useDispatch();

  const availableYears = createArrayYears().map((i) => ({ value: i, label: i }));

  useEffect(() => {
    return () => {
      dispatch(stateContractReset());
    };
  }, [dispatch]);

  const chooseYears = (i) => {
    setState(dataYears(i, viewReports.NBRB_MONTH, viewReports.NBRB_QUARTER));
  };

  const callReport = (param) => {
    const { type, title, dateFrom, dateTo, viewReport } = param;
    setReportTitle(title)
    const filename = title + '_' + moment().format('DD.MM.YYYY') + '.xlsx';

    dispatch(getPrintedForm({ dateFrom, dateTo }, filename, viewReport, type));
  };

  const createButtons = (data) => {
    return Object.values(data).map((i) => (
      <ActionButton
        key={i.title}
        text={i.title}
        styleName={(i.title === reportTitle && isLoading) ? 'reports-disabled-item' : 'button-pillbox'}
        func={callReport}
        param={i}
        disabled={ i.title === reportTitle && isLoading }
      />
    ));
  };
  return (
    <main className="app-content">
      <div className="content-header reportsNBRB-content-header">
        <h1>Отчетность и иная информация коммерческой микрофинансовой организации</h1>
        <div className="content-header-back reportsNBRB-content-header-back">
          <BackButton />
        </div>
      </div>
      <div className="content-inner">
        <div className="content-inner-data">
          <div className="content-inner-data-columns">
            <div className="content-inner-data-container widthContainer">
              {commonError && <Message type="error" text={commonError} />}
              { isLoading && <Message type={"info"} text={`Отчет ${reportTitle} загружается, подождите!`}/>}
              <fieldset>
                <div className="content-section-title m-b-0">
                  <div className="content-section-title-actionitems">
                    <Select
                      classNamePrefix="select"
                      className="basic-multi-select select-width"
                      placeholder="Выберите год"
                      options={availableYears}
                      onChange={chooseYears}
                      noOptionsMessage={() => 'Нет результатов'}
                    />
                  </div>
                </div>
              </fieldset>
              <fieldset>
                <div className="reports-cardscontainer">
                  <div className="reports-cardcolumn w-25">
                    <div className="reports-card">
                      <div className="reports-card-header">
                        <h4>Месячный</h4>
                      </div>
                      <div className="reports-card-content">
                        {state && createButtons(state.months)}
                      </div>
                    </div>
                  </div>
                  <div className="reports-cardcolumn w-25">
                    <div className="reports-card">
                      <div className="reports-card-header">
                        <h4>Квартальный</h4>
                      </div>
                      <div className="reports-card-content">
                        {state && createButtons(state.quarter)}
                      </div>
                    </div>
                  </div>
                  <div className="reports-cardcolumn w-25">
                    <div className="reports-card">
                      <div className="reports-card-header">
                        <h4>Годовой</h4>
                      </div>
                      <div className="reports-card-content">
                        {state && createButtons(state.year)}
                      </div>
                    </div>
                  </div>
                </div>
              </fieldset>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default ReportsNBRB;
